import type { RequestExtra } from 'Models/uiConfig/requestTypes';

export default async function convertibleFromObject(obj: RequestExtra): Promise<Record<string, string>> {
  return Object.fromEntries(
    await Promise.all(
      Object.entries(obj).map(async ([key, value]) => [
        key.toLowerCase(),
        encodeURIComponent(String(await value)),
      ]),
    ),
  );
}
